export const enClientPortalDashboardPage = {
    allPortfolios: 'All portfolios',
    noPortfoliosAvailable: 'No portfolios available',
    rentalIncome: 'Rental income',
    marketValueDevelopment: 'Market value development',
    marketRentDevelopment: 'Market rent development',
    marketValueShare: 'Market value share',
    mapOverview: 'Map overview',
    portfolioMarketValueShare: 'Portfolio market value share',
    formulas: {
        grossYield: '\\frac{\\text{Market rent} \\times 100}{\\text{Market value}}',
    },
}
